import * as React from 'react'
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {api} from '../api/api'
import countriesJson from '../countries.json'
import '../css/ghostCompletions.css'
import {ACCENT_TEXT, setTitleFont} from '../util/util'
import { locales } from '../util/locales'
import {Helmet} from 'react-helmet'

const COUNTRIES_VISIBLE = 'g-selector-countries g-s-c-block'
const COUNTRIES_HIDDEN = 'g-selector-countries g-s-c-none'

const C_TITLE_BORDERED = 'contact-input-container contact-input g-s-country-title'
const C_TITLE_NO_BORDERED = 'contact-input-container contact-input g-s-country-title g-s-t-no-border'

let countryToggle
let countries

let companyToggle

const GhostCompletions = () => {

    const [countriesFiltered, setCountriesFiltered] = useState(countriesJson)
    
    const [eName, setEName] = useState<string[]>([])
    const [eEmailAddress, setEEmailAddress] = useState<string[]>([])
    const [eCompanyName, setECompanyName] = useState<string[]>([])
    const [eCompanyType, setECompanyType] = useState<string[]>([])
    const [eCountry, setECountry] = useState<string[]>([])
    const [eOther, setEOther] = useState<string[]>([])

    const handleClick = (e) => {
        const companies: any = document.getElementById('g-s-companies')
        const companyLabel: any = document.getElementById('g-s-company-label')

        if (e.target.parentNode != countries && e.target != countryToggle) {
            countries.className = COUNTRIES_HIDDEN
            countryToggle.className = C_TITLE_BORDERED + (countryToggle.className.includes('error-input') ? ' error-input' : '')
            setCountriesFiltered(countriesJson)
        }

        if (e.target.parentNode != companies && e.target != companyToggle && e.target != companyLabel) {
            companyToggle.checked = false
        }
    }

    useEffect(() => {
        countryToggle = document.getElementById('g-s-country-toggle')
        countries = document.getElementById('g-s-countries')

        companyToggle = document.getElementById('g-s-company-toggle')

        setTitleFont(locales.en)
        document.onclick = handleClick
    }, [])

    const [form, setForm] = useState({
        Name: '',
        EmailAddress: '',
        CompanyName: '',
        CompanyType: '',
        Country: ''
    })

    const updateErrors = (Name, EmailAddress, CompanyName, CompanyType, Country) => {
        setEName(Name)
        setEEmailAddress(EmailAddress)
        setECompanyName(CompanyName)
        setECompanyType(CompanyType)
        setECountry(Country)
    }

    const sendFormData = async () => {
        updateErrors([], [], [], [], [])
        setEOther([])
        if (form.Name && form.EmailAddress && form.CompanyName && form.CompanyType && form.Country) {
            const {Name, EmailAddress, CompanyName, CompanyType, Country} = form

            const body = {
                Name,
                EmailAddress,
                CustomFields: [
                    {key: 'CompanyName', value: CompanyName},
                    {key: 'CompanyType', value: CompanyType},
                    {key: 'Country', value: Country}
                ],
                Resubscribe: true,
                RestartSubscriptionBasedAutoresponders: true,
                ConsentToTrack: 'Yes'
            }

            const windowReference = window.open()

            try {
                const resp = await api.postGhostCompletionsFormData(JSON.stringify(body))
                setForm({
                    ...form,
                    Name: '',
                    EmailAddress: '',
                    CompanyName: '',
                    CompanyType: '',
                    Country: '',
                })
                if (resp && windowReference) {
                    windowReference.location.replace('/personaly_white_paper_ghost_completions_june_2020.pdf')
                }
            } catch (e) {
                setEOther([e ? e.Message : 'server error'])
            }
        } else {
            updateErrors(
                form.Name ? [] : ['Required field'],
                form.EmailAddress ? [] : ['Required field'],
                form.CompanyName ? [] : ['Required field'],
                form.CompanyType ? [] : ['Required field'],
                form.Country ? [] : ['Required field']
            )
        }
    }

    const handleCompanyTypeSelect = e => {
        setForm({...form, CompanyType: e.currentTarget.textContent as string})
        companyToggle.checked = false
    }

    const handleCountrySelect = e => {
        setForm({...form, Country: e.currentTarget.textContent as string})
        setCountriesFiltered(countriesJson)
        countries.className = COUNTRIES_HIDDEN
        countryToggle.className = C_TITLE_BORDERED + (eCountry.length > 0 ? ' error-input' : '')
    }

    const renderCountries = () => {
        return countriesFiltered.map(country => <label onClick={handleCountrySelect} key={country.Code}>{country.Name}</label>)
    }

    const searchCountry = e => {
        const search = e.target.value
        setCountriesFiltered(countriesJson.filter(country => country.Name.toLowerCase().includes(search.toLowerCase())))
        setForm({...form, Country: search})
    }

    const activateCountryList = () => {
        countries.className = COUNTRIES_VISIBLE
        countryToggle.className = C_TITLE_NO_BORDERED + (eCountry.length > 0 ? ' error-input' : '')
    }

    return (
        <div className="ghost-comp">
            <Helmet>
                <title>Ghost Completions - The Venezuelan Fraud Scheme - Persona.ly</title>
                <meta name="title" content="Ghost Completions - The Venezuelan Fraud Scheme - Persona.ly" />
                <meta name="description" content="In this white paper we detail the technological vulnerabilities enabling these ghost completions, their estimated scale, and easily preventable measures the MR industry can take, as a whole, to prevent it." />
            </Helmet>
            <div className="g-p-logo"><Link to="/"><img src="https://static.persona.ly/images/logo_personaly.svg" /></Link></div>
            <div className="g-p-content">
                <div className="contact-left">
                    <div className="title muli"><span className={ACCENT_TEXT}>Ghost Completions</span> - The&nbsp;Venezuelan Fraud&nbsp;Scheme</div>
                    <div className="pre-text rgba087">Technological Vulnerabilities in the MR Industry in 2020.</div>
                    <div className="text-g g-main-descr rgba087">&quot;...This <span className={ACCENT_TEXT}>easily preventable vulnerability</span> enables&nbsp;<span className={ACCENT_TEXT}>wide&#8209;scale fraud</span> and hurts the market&nbsp;research&nbsp;industry throughout.&quot;</div>
                    <div className="ghost-title-ul rgba087">This white paper covers:</div>
                    <ul>
                        <li>1. How we’ve tracked and uncovered wide-scale ghost completions fraud originating in Venezuela.</li>
                        <li>2. Two simple ways to prevent a recurrence of this fraud - explained in detail.</li>
                        <li>3. The paradigm shift required for a long term industry-wide solution to effectively combat fraud in the MR industry.</li>
                    </ul>
                    <a className="ghost-share" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/shareArticle?mini=true&url=persona.ly/white_papers/ghost_completes_mr_05_2020/&title=&summary=&source=">
                        <img src="https://static.persona.ly/images/ghost_completions/group-8.svg" />
                        <span className="rgba087 fw500">Share on LinkedIn</span>
                    </a>
                </div>
                <div className="contact-right">
                    <img className="ghost-circle-3 not-mobile not-tablet" src="https://static.persona.ly/images/ghost_completions/group-6.svg" />
                    <div className="ghost-r-internal">
                        <div className="g-book-w">
                            <img className="g-book" src="https://static.persona.ly/images/ghost_completions/hardcover-book-mockup-presentation.webp" />
                            <img className="ghost-circle-1 not-mobile" src="https://static.persona.ly/images/ghost_completions/group-3.svg" />
                            <img className="ghost-circle-1-m not-tablet not-desktop" src="https://static.persona.ly/images/ghost_completions/group-37.svg" />
                        </div>
                        <div className="text-g g-download-descr rgba087 mt-30">Download Our <span className={ACCENT_TEXT}>White Paper</span></div>

                        {eOther && eOther.map(err => <div className="error" key={err}>{err}</div>)}

                        <div className="contact-input-container">
                            <input className={'contact-input small-text' + (eName.length > 0 ? ' error-input' : '')} type="input" name="name" placeholder="&nbsp;" value={form.Name}
                                onChange={e => setForm({...form, Name: e.currentTarget.value})} />
                            <span className="contact-input-label">Name*</span>
                        </div>
                        {eName && eName.map(err => <div className="error-small" key={err}>{err}</div>)}

                        <div className="contact-input-container">
                            <input className={'contact-input small-text' + (eEmailAddress.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;" value={form.EmailAddress}
                                onChange={e => setForm({...form, EmailAddress: e.currentTarget.value})} />
                            <span className="contact-input-label">Email address*</span>
                        </div>
                        {eEmailAddress && eEmailAddress.map(err => <div className="error-small" key={err}>{err}</div>)}

                        <div className="contact-input-container">
                            <input className={'contact-input small-text' + (eCompanyName.length > 0 ? ' error-input' : '')} type="input" name="company" placeholder="&nbsp;" value={form.CompanyName}
                                onChange={e => setForm({...form, CompanyName: e.currentTarget.value})} />
                            <span className="contact-input-label">Company name*</span>
                        </div>
                        {eCompanyName && eCompanyName.map(err => <div className="error-small" key={err}>{err}</div>)}

                        <div className="g-selector-w">
                            <input id="g-s-company-toggle" type="checkbox" />
                            <label id="g-s-company-label" className={'contact-input-container contact-input g-s-company-title' + (eCompanyType.length > 0 ? ' error-input' : '')} htmlFor="g-s-company-toggle">{form.CompanyType || 'Company type*'}<span /></label>
                            {eCompanyType && eCompanyType.map(err => <div className="error-small" key={err}>{err}</div>)}
                            <div id="g-s-companies" className="g-selector-companies">
                                <label onClick={handleCompanyTypeSelect}>Agency</label>
                                <label onClick={handleCompanyTypeSelect}>Buyer</label>
                                <label onClick={handleCompanyTypeSelect}>End Client</label>
                                <label onClick={handleCompanyTypeSelect}>Panel</label>
                                <label onClick={handleCompanyTypeSelect}>Supplier</label>
                                <label onClick={handleCompanyTypeSelect}>Technology Vendor</label>
                            </div>
                        </div>

                        <div className="g-selector-w">
                            <input
                                id="g-s-country-toggle"
                                className={C_TITLE_BORDERED + (eCountry.length > 0 ? ' error-input' : '')}
                                type="input"
                                required
                                onChange={searchCountry}
                                onClick={activateCountryList}
                                placeholder="Country*"
                                value={form.Country}
                            />
                            <span />
                            {eCountry && eCountry.map(err => <div className="error-small" key={err}>{err}</div>)}
                            <div id="g-s-countries" className={COUNTRIES_HIDDEN}>
                                {renderCountries()}
                            </div>
                        </div>

                        <div className="ghost-subscribe">
                            By clicking Download, you agree to receive occasional email content from Persona.ly. You can unsubscribe at any time.
                        </div>

                        <button className="button-blue large" onClick={sendFormData}>Download</button>
                    </div>
                    <img className="ghost-circle-2 not-mobile" src="https://static.persona.ly/images/ghost_completions/group-38.svg" />
                </div>
            </div>
        </div>
    )
}

export default GhostCompletions



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/ghostCompletions.tsx